import { storeAction } from "../storeActions.constant";
import { storeGetters } from "../storeGetters.constant";
import { storeMutation } from "../storeMutations.constant";

const ypoConciergeState = {
    baseURL: process.env.VUE_APP_BASE_URL,
    config: {
        conciergeBaseUrl: process.env.VUE_APP_YPO_CONCIERGE_BASE_URL,
        conciergePortal: process.env.VUE_APP_YPO_CONCIERGE_PORTAL,
        orgId: process.env.VUE_APP_YPO_CONCIERGE_ORG_ID,
        conciergeSource: process.env.VUE_APP_YPO_CONCIERGE_SOURCE,
        deploymentId: process.env.VUE_APP_YPO_CONCIERGE_DEPLOYMENT_ID,
        buttonId: process.env.VUE_APP_YPO_CONCIERGE_BUTTON_ID,
        forceDefaultSource: 'https://service.force.com',
        baseLiveAgentContentURL: process.env.VUE_APP_YPO_CONCIERGE_BASE_AGENT_CONTENT_URL,
        baseLiveAgentURL: process.env.VUE_APP_YPO_CONCIERGE_BASE_AGENT_URL,
        eswLiveAgentDevName: process.env.VUE_APP_YPO_CONCIERGE_AGENT_NAME,
        recordTypeOther: process.env.VUE_APP_YPO_CASE_CONCIERGE_ID || '012610000005yab', // type: Concierge
    },
    userData: {
        firstName: '',
        lastName: '',
        email: 'anonymous@anonymous.com',
        topic: 'Renewals/Membership',
    },
    isAgentAvailable: false,
    conciergeScriptLoaded: false,
    conciergeActive: false,
    conciergeFeatureFlag: {
        ypoConciergeEnabled: true,
    },
};

const ypoConciergeMutations = {
    [storeMutation.setYpoConciergeUser]: (state, data) => {
        const { firstName, lastName, email } = data;
        if (firstName && lastName && email) {
            state.userData = {
                ...state.userData,
                firstName,
                lastName,
                email,
            };
        }
    },
    [storeMutation.setConciergeFeatureFlag]: (state, data) => {
        state.conciergeFeatureFlag.ypoConciergeEnabled = data.ypoConciergeEnabled;
    },
    [storeMutation.setYpoConciergeAgentAvailability]: (state, data) => {
        state.isAgentAvailable = data || false;
    },
    [storeMutation.setConciergeScriptLoadedStatus]: (state, data) => {
        state.conciergeScriptLoaded = data || false;
    },
    [storeMutation.setConciergeActiveStatue]: (state, data) => {
        state.conciergeActive = data || false;
    },
};

const ypoConciergeActions = {
    [storeAction.initiateConciergeService]: ({ state, commit }, gslbBaseURL) => {
        if (window && window.embedded_svc) {
            window.embedded_svc.settings.displayHelpButton = false; //Or false
            window.embedded_svc.settings.language = ''; //For example, enter 'en' or 'en-US'
            window.embedded_svc.settings.defaultMinimizedText = 'Chat with YPO';
            window.embedded_svc.settings.enabledFeatures = ['LiveAgent'];
            window.embedded_svc.settings.entryFeature = 'LiveAgent';
            window.embedded_svc.settings.extraPrechatFormDetails = [
                {
                    "label": "Text",
                    "transcriptFields": ["PrechatText__c"],
                },
            ];

            window.embedded_svc.addEventHandler("onSettingsCallCompleted", (data) => {
                if (data) {
                    commit(storeMutation.setYpoConciergeAgentAvailability, data.isAgentAvailable);
                }
            });

            window.embedded_svc.addEventHandler("onAvailability", (data) => {
                if (data) {
                    commit(storeMutation.setYpoConciergeAgentAvailability, data.isAgentAvailable);
                }
            });

            window.embedded_svc.addEventHandler("afterinitialization", () => {
                commit(storeMutation.setConciergeActiveStatue, true);
            });

            window.embedded_svc.addEventHandler("afterDestroy", () => {
                commit(storeMutation.setConciergeActiveStatue, false);
            });

            window.embedded_svc.settings.extraPrechatFormDetails = [{
                "label": "First Name",
                "value": state.userData.firstName,
                "displayToAgent": true,
                "transcriptFields": ["First_Name__c"],
            }, {
                "label": "Last Name",
                "value": state.userData.lastName,
                "displayToAgent": true,
                "transcriptFields": ["Last_Name__c"],
            }, {
                "label": "Email",
                "value": state.userData.email,
                "displayToAgent": true,
                "transcriptFields": ["Email__c"],
            }, {
                "label": "Topic",
                "value": "Events",
                "displayToAgent": true,
                "transcriptFields": ["Chat_Topic__c"],
            }];

            window.embedded_svc.settings.extraPrechatInfo = [{
                "entityFieldMaps": [{
                    "doCreate": false,
                    "doFind": true,
                    "fieldName": "LastName",
                    "isExactMatch": true,
                    "label": "Last Name",
                }, {
                    "doCreate": false,
                    "doFind": true,
                    "fieldName": "FirstName",
                    "isExactMatch": true,
                    "label": "First Name",
                }, {
                    "doCreate": false,
                    "doFind": true,
                    "fieldName": "Email",
                    "isExactMatch": true,
                    "label": "Email",
                }],
                "entityName": "Contact",
                "showOnCreate": false,
            }];

            document.addEventListener("setfield", (event) => {
                window.embedded_svc.settings.extraPrechatFormDetails.forEach((setting) => {
                    if (setting.label) {
                        if (setting.label.toLowerCase() === "first name") {
                            setting.value = state.userData.firstName;
                        } else if (setting.label.toLowerCase() === "last name") {
                            setting.value = state.userData.lastName;
                        } else if (setting.label.toLowerCase() === "email") {
                            setting.value = state.userData.email;
                        } else if (setting.label.toLowerCase() === "topic") {
                            setting.value = event.detail.customField;
                        }
                    }
                });
                event.detail.callback();
            }, false);

            window.embedded_svc.init(
                state.config.conciergeBaseUrl,
                state.config.conciergePortal,
                gslbBaseURL,
                state.config.orgId,
                'YPO_Concierge_Team',
                {
                    baseLiveAgentContentURL: state.config.baseLiveAgentContentURL,
                    deploymentId: state.config.deploymentId,
                    buttonId: state.config.buttonId,
                    baseLiveAgentURL: state.config.baseLiveAgentURL,
                    eswLiveAgentDevName: state.config.eswLiveAgentDevName,
                    isOfflineSupportEnabled: false,
                },
            );

            commit(storeMutation.setConciergeScriptLoadedStatus, true);
        }
    },
    [storeAction.determineConciergeServiceAvailability]: ({ state, dispatch, commit }) => {
        commit(storeMutation.setConciergeScriptLoadedStatus, false);
        if (!window.embedded_svc) {
            const s = document.createElement('script');
            s.setAttribute('src', state.config.conciergeSource);
            s.onload = () => {
                dispatch(storeAction.initiateConciergeService, null);
            };
            document.body.appendChild(s);
        } else {
            dispatch(storeAction.initiateConciergeService, state.config.forceDefaultSource);
        }
    },
};
const ypoConciergeGetters = {
    [storeGetters.ypoConciergeTopics]: state => state.ypoConciergeTopics,
    [storeGetters.isYpoConciergeAgentAvailable]: state => state.isAgentAvailable,
    [storeGetters.isConciergeScriptLoaded]: state => state.conciergeScriptLoaded,
    [storeGetters.isConciergeActive]: state => state.conciergeActive,
    [storeGetters.conciergeFeatureFlag]: state => state.conciergeFeatureFlag,
    [storeGetters.conciergeUserData]: state => state.userData,
};

export default {
    namespaced: true,
    state: {
        initialState: ypoConciergeState,
        ...ypoConciergeState,
    },
    mutations: { ...ypoConciergeMutations },
    actions: { ...ypoConciergeActions },
    getters: { ...ypoConciergeGetters },
};
